import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const LARGE = 1279;

const dismissDropdown = () => {
  $( '.chr-white-overlay' ).fadeOut();
  $( 'body' ).removeClass( 'filter-dropdown-open' );
  clearAllBodyScrollLocks();
};

const toggleFade = ( target, chosen ) => {
  if ( chosen ) {
    $( target ).removeClass( 'hidden-content' );
  } else {
    $( target ).addClass( 'hidden-content' );
  }
};

const filteringContent = ( filters ) => {
  let target = '.syncable-content .tab-content div[data-has-filters]';

  $( target ).each( function() {
    let self = $( this );

    let ids = self.data( 'filter-term-ids' );
    let list = ids.toString().split( ',' );
    let canShow = false;

    for ( let index = 0; index < list.length; index++ ) {
      const elem = list[index];
      if ( filters.includes( elem.toString() ) ) {
        canShow = true;
        break;
      }
    }
    toggleFade( self, canShow );
  });
};

console.log("test from dev1");

const resetContent = () => {
  let target = '.syncable-content .tab-content';
  $( target ).each( function() {
    $( this ).removeClass( 'hidden-content' );
    $( this ).find( 'div[data-has-filters]' ).removeClass( 'hidden-content' );
  });

  $( '.syncable-content .tab-content' ).removeClass( 'hide' );
};

const syncCheckboxes = ( target, sync ) => {
  $( target ).each( function() {
    $( this ).on( 'click', function() {
      $( this ).toggleClass( 'checked' );
      let attr = '[data-filter-id="' + $( this ).data( 'filter-id' ) + '"]';

      if ( $( this ).hasClass( 'checked' ) ) {
        $( sync + attr ).addClass( 'checked' );
      } else {
        $( sync + attr ).removeClass( 'checked' );
      }
    });
  });
};

const syncChosenFilters = ( filter, isAdding ) => {
  let data = $( '.syncable-filters[data-chosen-filters]' ).data( 'chosen-filters' );

  if ( isAdding ) {
    if ( data ) {
      data += ',' + filter;
    } else {
      data = filter.toString();
    }
  } else {
    data = data.split( ',' ).filter( function( elem ) {
      return elem.toString() !== filter.toString();
    }).toString(); // Subtract elem from id list
  }

  $( '.syncable-filters' )
    .data( 'chosen-filters', data );

  if ( data ) {
    return $( '.syncable-filters[data-chosen-filters]' )
      .data( 'chosen-filters' ).toString().split( ',' );
  }
  return false;
};

const filteringSlick = ( content, mode, classname ) => {
  $( content ).find( '.slick-slider.slick-initialized' ).each( function() {
    let slider = $( this );
    slider.slick( mode, classname );
    slider.slick( 'setPosition' );
  });
};

const getSidebarAndContent = ( type ) => {
  let sidebar = undefined;
  let content = undefined;

  if ( type === 'product' ) {
    sidebar = '.all-products-tabs__filter';
    content = '.all-products-tabs__content';
  } else {
    sidebar = '.support-tabs__filter';
    content = '.support-tabs__content';
  }

  return {
    sidebar: sidebar,
    content: content
  };
};

/**
 * Triggers filter actions
 * @param {String} type - type
 * @returns {Void} void
 */
export function handleFiltersChanges( type ) {

  let { sidebar, content } = getSidebarAndContent( type );

  let box1 = sidebar + '__wrapper.desktop .syncable-filters .filters .option';
  let box2 = sidebar + '__wrapper.mobile .syncable-filters .filters .option';

  syncCheckboxes( box1, box2 );
  syncCheckboxes( box2, box1 );

  $( sidebar + ' .filters .option' ).each( function() {
    let self = $( this );

    self.on( 'click', function() {
      $( content ).find( '.slick-slider.slick-initialized' ).each( function() {
        $( this ).slick( 'slickUnfilter' );
      });
      $( '.products-group .products .no-result' ).remove();
      let filter = self.data( 'filter-id' );
      let chosenFilters = syncChosenFilters( filter, $( self ).hasClass( 'checked' ) );
      if ( ! chosenFilters || ! chosenFilters.length ) {
        resetContent();
        filteringSlick( content, 'slickUnfilter', ':not(.hidden-content)' );
      } else {
        filteringContent( chosenFilters );
        filteringSlick( content, 'slickFilter', ':not(.hidden-content)' );
      }

      $( '.products-group .products' ).each( ( index, single ) => {

        if ( $( single ).find( '.single-object' ).length ===
          $( single ).find( '.hidden-content' ).length ) {

          $( single ).append( '<p class="no-result">No results found!</p>' );
        }

      });

    });
  });
}

/**
 * Toggle Filter Dropdown
 * @param {String} dropdown - String of dropdown
 * @param {String} sidebar - String of sidebar
 * @returns {Void} void
 */
export function toggleFilterDropdown( dropdown, sidebar ) {
  let $dropdown = $( dropdown );
  let parent = $( sidebar )[0];
  let $overlay = $( '.chr-white-overlay' );
  let $clearBtn = $( '.syncable-filters__wrapper.mobile .clear-btn' );

  $dropdown.on( 'click', function() {
    $( 'html,body' ).animate({
      scrollTop: $dropdown.parent().offset().top - $( 'header' ).height()
    }, 450 );
    $( 'body' ).toggleClass( 'filter-dropdown-open' );

    if ( $( 'body' ).hasClass( 'filter-dropdown-open' ) ) {
      $overlay.fadeIn();
      disableBodyScroll( parent );
    } else {
      $overlay.fadeOut();
      enableBodyScroll( parent );
    }

    $overlay.click( () => {
      dismissDropdown();
    });

    $clearBtn.click( () => {
      dismissDropdown();
    });
  });
}

/**
 * Sticky Filter bar
 * @param {String} dropdown - String of dropdown
 * @returns {Void} void
 */
export function stickyFilter( dropdown ) {
  let $dropdown = $( dropdown );
  let $placholder = $( dropdown ).next( '.filter-placeholder' );

  $( window ).scroll( function() {
    if ( window.innerWidth < LARGE ) {
      let headerHeight = $( '.chr-header' ).height();
      let dropdownOffsetTop;
      let st = $( window ).scrollTop();
      let adminBarH = 0;
      let fixedClass = 'fixed';
      if ( $( '#wpadminbar' ) && $( '#wpadminbar' ).length ) {
        adminBarH = $( '#wpadminbar' ).height();
      }

      if ( $dropdown && $dropdown.length > 0 ) {
        let dropdownH = $dropdown.outerHeight( true );
        dropdownOffsetTop = $placholder.offset().top - dropdownH;

        if ( $( 'body' ).hasClass( 'sticky-breadcrumb' ) ) {
          fixedClass = 'fixed--second';
          dropdownOffsetTop -= $( '.chr-breadcrumbs-wrapper.fixed' ).outerHeight( true );
        }

        if ( st < dropdownOffsetTop - headerHeight - adminBarH ) {
          $dropdown.removeClass( fixedClass );
          $placholder.css( 'height', '0' );
        } else {
          $dropdown.addClass( fixedClass );
          $placholder.css( 'height', dropdownH + 'px' );
        }
      }
    }
  });

}

let documentationType = document.getElementsByClassName('documentation-type');

for (let i = 0; i < documentationType.length; i++){
  documentationType[i].addEventListener('click', handleClick(documentationType[i]));

}

function handleClick(type) {

  if(document.getElementById('doc-item-view')) {
    document.getElementById('doc-item-view').style.display = 'block';
  }

}
